export const Bio = {
  name: "Aslam Anwar",
  roles: [
    "Red Teamer",
    "Penetration Tester",
    "Cybersecurity Researcher",
  ],
  description:
    "As a Red Teamer and Penetration Tester, I focus on finding vulnerabilities and enhancing security measures. My passion for cybersecurity drives me to continuously learn and stay ahead of emerging threats.",
  github: "https://github.com/AslamMahi",
  resume:
    "/AslamMahimkar-Resumev.pdf",
  linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
  /*twitter: "https://twitter.com/RishavChanda",*/

};

export const skills = [
  {
    title: "Network Cert's",
    skills: [
      {
        name: "CCIE SP",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CCIE%20SP.svg?alt=media&token=cfebf806-a212-468d-afeb-14b801e2fffe",
      },
      {
        name: "CCIE ENT",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CCIE%20ENT.svg?alt=media&token=3ac67d4f-ff3a-4dd2-9986-fc4080f2f1c0",
      },
      {
        name: "CSS ENT",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CSS%20ENT.svg?alt=media&token=0e4ac45b-ded4-4e57-97bc-65981b194714",
      },
      {
        name: "CSS SP",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CSS%20SP.svg?alt=media&token=5eeeaadf-2289-425f-b0f3-35f3b3a6dd34",
      },
      /*{
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },*/
      {
        name: "CCNP",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CCNP%20R%26S.svg?alt=media&token=89a7af8c-2e7c-4bcb-ad88-bbdb2c13bf00",
      },
      {
        name: "CCNA",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CCNA%20R%26S.svg?alt=media&token=a257d65d-5c42-4cdd-86fd-c38d06a03cf8",
      },
      
    ],
  },
  {
    title: "CyberSec Cert's",
    skills: [
      {
        name: "CISSP",
        image: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CISSP.svg?alt=media&token=839fcf7f-3ed5-4fe8-97d0-efcd510094c3",
      },
      {
        name: "OSCP",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/OSCP.svg?alt=media&token=e66957ce-e1a3-48f7-a65c-8616ec800152",
      },
      {
        name: "CC",
        image: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CC.svg?alt=media&token=460263dd-1eb2-4e0a-a964-ce8c8cb2c5ac",
      },
      /*{
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      },
      {
        name: "Django",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },*/
      {
        name: "MCP",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/MCP.svg?alt=media&token=b4067e5d-7d7a-4526-b32d-15c8856e4162",
      },
      {
        name: "ITIL V3",
        image:
          "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/ITIL.svg?alt=media&token=b72a30cb-6ddd-49f3-8c70-7b4ea732f168",
      },
    ],
  },
  /*{
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
      },
      {
        name: "Nginx",
        image: "https://download.logo.wine/logo/Nginx/Nginx-Logo.wine.png",
      },
      {
        name: "Grafana",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/1200px-Grafana_logo.svg.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
      {
        name: "Prometheus",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "Jetpack Compose",
        image:
          "https://3.bp.blogspot.com/-VVp3WvJvl84/X0Vu6EjYqDI/AAAAAAAAPjU/ZOMKiUlgfg8ok8DY8Hc-ocOvGdB0z86AgCLcBGAsYHQ/s1600/jetpack%2Bcompose%2Bicon_RGB.png",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },*/
  {
    title: "Pentest Tools",
    skills: [
      /*{
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tenserflow",
        image:
          "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
      },
      {
        name: "Keras",
        image:
          "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      },
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },*/
      {
        name: "Kali Linux",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/2/2b/Kali-dragon-icon.svg",
      },
      
      {
        name: "Nmap",
        image:
          "https://raw.githubusercontent.com/bwks/vendor-icons-svg/702f2ac88acc71759ce623bc5000a596195e9db3/nmap-logo.svg",
      },
      {
        name: "Wireshark",
        image:
          "https://raw.githubusercontent.com/bwks/vendor-icons-svg/702f2ac88acc71759ce623bc5000a596195e9db3/wireshark.svg",
      },
      {
        name: "Metasploit",
        image:
          "https://www.kali.org/tools/metasploit-framework/images/metasploit-framework-logo.svg",
      },
      {
        name: "Aircrack-ng",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/c3/Aircrack-ng-new-logo.jpg",
      },
      {
        name: "Sqlmap",
        image:
          "https://cdn.brandfetch.io/idha8gcsl6/w/807/h/417/theme/dark/logo.png?k=id64Mup7ac&t=1724778940199?t=1724778940199",
      },
      {
        name: "Bloodhound",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Nessus",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/c1/Nessus-Professional-FullColor-RGB.svg",
      },
      {
        name: "BrupSuit Pro",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/f/f2/Logo_of_PortSwigger.svg",
      },
      {
        name: "Powershell Empire",
        image:
          "https://www.stationx.net/wp-content/uploads/2023/09/powershell-empire-featured-image.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Linux",
        image:
          "https://raw.githubusercontent.com/bwks/vendor-icons-svg/702f2ac88acc71759ce623bc5000a596195e9db3/linux.svg",
      },
      {
        name: "Windows",
        image:
          "https://raw.githubusercontent.com/bwks/vendor-icons-svg/702f2ac88acc71759ce623bc5000a596195e9db3/windows-2012.svg",
      },
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Powershell",
        image:
          "https://raw.githubusercontent.com/gist/Xainey/d5bde7d01dcbac51ac951810e94313aa/raw/6c858c46726541b48ddaaebab29c41c07a196394/PowerShell.svg",
      },
      {
        name: "Bash",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Bash_Logo_Colored.svg/512px-Bash_Logo_Colored.svg.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      /*{
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },*/
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/Emblem_of_Qatar_(2022%E2%80%93present).svg?alt=media&token=d1792b72-2b63-411c-a129-4e623f06e1f0",
    role: "Penetration Tester / Read Team Assessment",
    company: "SELF, Doha, Qatar",
    date: "September 2022–Present ",
    desc: `Since September 2022, I have focused on Red Team and Cloud Security, building labs for penetration testing, Active Directory attacks, and lateral movement. I assess Azure and AWS environments for misconfigurations and privilege escalation, perform web application testing using OWASP Top 10 methods, automate tasks with scripting, and document findings through technical blogs and reports..`,
    skills: [
      "Penetration Testing",
      "Vulnerability Scanning",
      "Active Directory",
      "Privilege Escalation",
      "Lateral Movement",
      "Encryption",
      "Authentication",
      "Network Configuration",
      "Scripting",
      "Coding Languages",
      "Linux",
      "UNIX",
      "Command-Line Interfaces",
      "Security Procedures"
    ],
    
    doc: "https://en.wikipedia.org/wiki/Emblem_of_Qatar#/media/File:Emblem_of_Qatar_(2022%E2%80%93present).svg",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/Emblem_of_Qatar_(2022%E2%80%93present).svg?alt=media&token=d1792b72-2b63-411c-a129-4e623f06e1f0",
    role: "Senior System Engineer",
    company: "Telecommunication Department, Doha, Qatar",
    date: "May 2018–present",
    desc: "Directed high-impact projects focused on network infrastructure and NOC system deployment, including IT service management (ITSM) integration. Optimized IT workflows, aligned strategic roadmaps with business goals, and led stakeholder engagement for successful implementations. Managed NOC setup, ensuring security compliance and seamless integration of ITSM processes. Oversaw project execution, risk management, and stakeholder communication to ensure timely delivery and quality outcomes.",
    skills: [
      "Network Infrastructure",
      "Data Management",
      "NOC Systems",
      "NMS",
      "BMC",
      "NetAct",
      "ITSM Tools",
      "IT Infrastructure Optimization",
      "Stakeholder Engagement",
      "ITSM Process Design",
      "Incident Management",
      "Change Management",
      "Problem Management",
      "Service Level Management",
      "ITSM Testing",
      "Monitoring Systems",
      "Security Protocols",
      "Project Management",
      "Budget Management",
      "Risk Mitigation",
      "Quality Standards"
    ],
    
    doc: "https://en.wikipedia.org/wiki/Emblem_of_Qatar#/media/File:Emblem_of_Qatar_(2022%E2%80%93present).svg",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/Emblem_of_Qatar_(2022%E2%80%93present).svg?alt=media&token=d1792b72-2b63-411c-a129-4e623f06e1f0",
    role: "Assistant System Engineer",
    company: "Telecommunication Department, Doha, Qatar",
    date: "April 2014–April 2018",
    desc: "Optimized network monitoring using Opentext Microfocus, achieving 99.9% uptime and reducing false alerts by 40%. Provided first-level support for network disruptions, improving resolution time by 30% and boosting customer satisfaction by 20%. Assisted with network setup and maintenance, performed regular diagnostics, and ensured compliance with security protocols to maintain smooth operations.",
    skills: [
      "Opentext Microfocus",
      "Network Monitoring",
      "BMC Remedy",
      "Incident Management",
      "Network Uptime",
      "System Diagnostics",
      "Network Infrastructure",
      "Security Compliance",
      "Customer Satisfaction"
    ],    
    doc: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/Emblem_of_Qatar_(2022%E2%80%93present).svg?alt=media&token=d1792b72-2b63-411c-a129-4e623f06e1f0",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/23f578df-71ea-495f-b86c-5a58e8bdd3c7.png?alt=media&token=d04812de-e7ae-4e09-8064-b3a3a0453910",
    role: "Network Support Engineer",
    company: "Spanco BPO Service Limited",
    date: "MAY 2012 - MARCH 2014",
    desc: "Optimized network infrastructure and resolved technical issues to ensure seamless connectivity and security. Proven expertise in network configuration and support.",
    skills: [
      "Network Configuration",
      "Troubleshooting",
      "TCP/IP, DNS, DHCP",
      "VLANs, VPNs",
      "Firewalls, Security",
      "Monitoring Tools",
      "Routers, Switches",
      "Wi-Fi Technologies",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/23f578df-71ea-495f-b86c-5a58e8bdd3c7.png?alt=media&token=d04812de-e7ae-4e09-8064-b3a3a0453910",
  },
  /*{
    id: 4,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "Android Developer",
    company: "DSC KIIT",
    date: "Nov2021 - Present",
    desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
    skills: [
      "Leadership",
      "Mobile Application Development",
      "Kotlin",
      "XML",
      "Figma",
    ],
  },
  {
    id: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2023 - Present",
    desc: "Contributed to different open-source projects and learn from industry experts",
  },*/
];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/Screenshot%202024-09-02%20123223.png?alt=media&token=1432557d-fc82-4bea-ab60-f6766f5ed5a1",
    school: "ICOER (Imperial college of engineering and Research, Pune",
    date: "APRIL 2008 - APRIL 2012",
    grade: "Distinction",
    degree: "Bachelor of Engineering- B.E, Electronics and Telecommunication",
  },
  /*
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "Methodist School, Dankuni",
    date: "Apr 2019 - Apr 2025",
    grade: "88.2%",
    desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
    degree: "ISC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "Methodist School, Dankuni",
    date: "Apr 2017 - Apr 2019",
    grade: "92.3%",
    desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
  },
  */
];

export const projects = [
  {
    id: 11,
    title: "CVE-2024-36597",
    date: "18-05-2024",
    description:
      "Aegon Life v1.0 was discovered to contain a SQL injection vulnerability via the client_id parameter at clientStatus.php.Important user data or system data may be leaked and system security may be compromised. Then environment is secure and the information can be used by malicious users..",
    image:
      "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CVE-2024-36597.png?alt=media&token=2cd28a77-1a61-41c7-bb4d-0fdd4a2e5446",
    tags: [
      "Mysql",
      "sqlmap",
      "SQL injection",
      "Information disclosure",
    ],
    category: "web app",
    github: "https://github.com/kaliankhe/CVE-Aslam-mahi/blob/9ec0572c68bfd3708a7d6e089181024131f4e927/vendors/projectworlds.in/AEGON%20LIFE%20v1.0%20Life%20Insurance%20Management%20System/CVE-2024-36597",
    /*webapp: "https://projectworlds.in/life-insurance-management-system-in-php/",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  {
    id: 9,
    title: "CVE-2024-36598",
    date: "18-05-2024",
    description:
      "An arbitrary file upload vulnerability in Aegon Life v1.0 allows attackers to execute arbitrary code via uploading a crafted PHP file by adding image/gif magic bytes in payload.In insertClient.php fileToUpload is only checking for image file but not checking for extensions, also header.php is not properly handling the redirection hence allowing Unauthenticated redirect.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CVE-2024-36598.png?alt=media&token=873938a9-aaae-471d-a15b-80293ff4dcdd",
    tags: [
      "RCE",
      "File Upload",
      "Information disclosure",
      "Privilage Escalation",
    ],
    category: "web app",
    github: "https://github.com/kaliankhe/CVE-Aslam-mahi/blob/9ec0572c68bfd3708a7d6e089181024131f4e927/vendors/projectworlds.in/AEGON%20LIFE%20v1.0%20Life%20Insurance%20Management%20System/CVE-2024-36598",
    /*webapp: "https://trackify-management.netlify.app/",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  {
    id: 0,
    title: "CVE-2024-36599",
    date: "18-05-2024",
    description:
      "A cross-site scripting (XSS) vulnerability in Aegon Life v1.0 allows attackers to execute arbitrary web scripts or HTML via a crafted  payload injected into the name parameter at insertClient.php.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/CVE-2024-36599.png?alt=media&token=09fd327f-d860-4ecb-9946-560a648fa429",
    tags: ["XSS", "MInformation disclosure", ],
    category: "web app",
    github: "https://github.com/AslamMahi/CVE-Aslam-Mahi/blob/main/AEGON%20LIFE%20v1.0%20Life%20Insurance%20Management%20System/CVE-2024-36599",
    /*webapp: "https://podstream.netlify.app/",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  {
    id: 1,
    title: "CVE-2024-44727",
    date: "13-08-2024",
    description:
      "Sourcecodehero Event Management System 1.0 allows SQL Injection via parameter 'username' in /event/admin/login.php. Exploiting this issue could allow an attacker to compromise the application, access or modify data, or exploit latest vulnerabilities in the underlying database.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/sitimageeventmanamgment.png?alt=media&token=7f707810-281c-4b5b-8f44-f6255d8e3c07",
    tags: [
      "Mysql",
      "sqlmap",
      "SQL injection",
      "Information disclosure",
    ],
    category: "web app",
    github: "https://github.com/AslamMahi/CVE-Aslam-Mahi/blob/main/Sourcecodehero%20Event%20Management%20System/CVE-2024-44727.MD",
    /*webapp: "https://vexa-app.netlify.app/",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  {
    id: 2,
    title: "CVE-2024-44728",
    date: "13-08-2024",
    description:
      "Sourcecodehero Event Management System 1.0 allows Stored Cross-Site Scripting via parameters 'Full Name', 'Address', 'Email' and 'contact#' in /clientdetails/admin/register. Client_Details_System is vulnerable to a cross-site scripting vulnerability because it fails to sufficiently sanitize user-supplied data. An attacker may leverage this issue to execute arbitrary script code in the browser of an unsuspecting user in the context of the affected site. This may allow the attacker to steal cookie-based authentication credentials and launch other attacks..",
    image:
      "https://firebasestorage.googleapis.com/v0/b/myportfolio-1e227.appspot.com/o/sitimageeventmanamgment.png?alt=media&token=7f707810-281c-4b5b-8f44-f6255d8e3c07",
      tags: ["XSS", "Information disclosure", ],
    category: "web app",
    github: "https://github.com/AslamMahi/CVE-Aslam-Mahi/blob/main/Sourcecodehero%20Event%20Management%20System/CVE-2024-44728.md",
    /*webapp: "https://brain-tumor.netlify.app/",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  {
    id: 19,
    title: "CVE-2024-45932",
    date: "20-08-2024",
    description:
      "The Laravel CRM v1.3.0 web application is vulnerable to a persistent XSS vulnerability in the organization name field. When a user enters a malicious payload into the organization name field in /laravel-crm/admin/contacts/organizations/edit/2, this payload is executed when the user later views the associated person’s page.This occurs due to the organization name being reflected on the person’s page without proper sanitization or escaping.",
    image:
      "https://ppcl.com/wp-content/uploads/2022/01/PPCL_Icons_CVE_600_Tiny-480x480.png",
    tags: ["XSS", "Information disclosure", ],
    category: "web app",
    github: "https://github.com/AslamMahi/CVE-Aslam-Mahi/blob/main/Laravel%20CRM%20v1.3.0/CVE-2024-45932.md",
    /*webapp: "https://podstream.netlify.app/",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  {
    id: 20,
    title: "CVE-2024-45933",
    date: "24-08-2024",
    description:
      "A stored cross-site scripting (XSS) vulnerability exists in MobinaJafarian/OnlineNewsSite v 1.0 that can allows a low-privilege user to create malicious post content with HTML inside it, which acts as a stored XSS payload. If this post page is visited by anyone including the administrator, then the XSS payload will be triggered.",
    image:
      "https://ppcl.com/wp-content/uploads/2022/01/PPCL_Icons_CVE_600_Tiny-480x480.png",
    tags: ["XSS", "Information disclosure", ],
    category: "web app",
    github: "https://github.com/AslamMahi/CVE-Aslam-Mahi/blob/main/MobinaJafarian-OnlineNewsSite%20v%201.0/CVE-2024-45933.md",
    /*webapp: "https://podstream.netlify.app/",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  /*{
    id: 3,
    title: "Buckoid",
    date: "Dec 2021 - Apr 2022",
    description:
      "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
    image:
      "https://camo.githubusercontent.com/3ad28aa710d18525f1fc87de056ed53c706d09979589bfd5a773df36653bad38/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    category: "android app",
    github: "https://github.com/rishavchanda/Buckoid-Android-App",
    webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },*/
  {
    id: 10,
    title: "WiFi Pentesting",
    date: "September 2024",
    description:
      "Step-by-step approach to WiFi pentesting, designed for both beginners and intermediate users.",
    image:
      "https://camo.githubusercontent.com/ea0e58f9b84e0c151fb3d82b41f1ae628bedb488d28a3e6ee01757d7c5d91784/68747470733a2f2f6d656469612e6c6963646e2e636f6d2f646d732f696d6167652f76322f44353632324151477745332d6d50574a4934512f6665656473686172652d736872696e6b5f323034385f313533362f6665656473686172652d736872696e6b5f323034385f313533362f302f313638303637363938353736313f653d3231343734383336343726763d6265746126743d31576e753830714a454e7a344d3044726448636c6e376574456b6d7137726b715143425967395432717859",
    tags: ["DOS Attacks", "Deauthentication Attack", "AWPS Brute Force Attack", "Cracking WEP"],
    category: "android app",
    github: "https://github.com/AslamMahi/WiFi-Pentesting",
    /*webapp: "https://github.com/rishavchanda/Job-finder-App",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  /*{
    id: 4,
    title: "Whatsapp Clone",
    date: "Jul 2021",
    description:
      "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    webapp: "https://whatsapp-clone-rishav.web.app",
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      {
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },
  /*{
    id: 5,
    title: "Todo Web App",
    date: "Jun 2021",
    description:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://camo.githubusercontent.com/84ac6ab6f378348ef28d8184062b7e9e3511a1252ae3966eaa49e8e998f732a7/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Todo-Web-App",
    webapp: "https://rishav-react-todo.netlify.app/",
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      {
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },*/
  /*{
    id: 6,
    title: "Breaking Bad",
    date: "Jun 2021",
    description:
      "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
    image:
      "https://camo.githubusercontent.com/937774368308a82419f53dd6eeb4a8675780e119636488b4e3cfe5d34859a72a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
    tags: ["React Js", "API", "Axios", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Breaking-Bad",
    webapp: "https://breaking-bad-webapp.netlify.app",
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },*/
  {
    id: 7,
    title: "Pentest Blogs",
    date: "20 May 2024 - PRESENT",
    description:
      "This blog dives deep into the world of penetration testing, sharing insights and practical knowledge from OSCP preparation, Hack The Box challenges, and PortSwigger Web Security research. Explore hands-on tutorials, exploit walkthroughs, and valuable tips for improving your offensive security skills. Whether you're preparing for certifications like OSCP or sharpening your hacking techniques, this blog offers a wealth of knowledge for ethical hackers and cybersecurity enthusiasts.",
    image:
      "https://miro.medium.com/v2/resize:fit:4800/format:webp/1*cbyNf_R8Ld_ZzKVv07Ezag.jpeg",
    tags: ["PortSwigger", "exploit", "walkthroughs", "OSCP", "Hack The Box", "offensive", "penetration testing"],
    category: "android app",
    github: "https://medium.com/@aslam.mahimkar",
    /*webapp: "https://github.com/rishavchanda/Quiz-Earn",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  {
    id: 8,
    title: "HoneyLogix_HoneyPot",
    date: "September 2024",
    description:
      "This project is a lightweight SSH and HTTP Honeypot that logs unauthorized access attempts, capturing IP addresses, usernames, passwords, and commands. By simulating a vulnerable service, it attracts attackers and provides valuable data for security research and analysis.",
    image:
      "https://raw.githubusercontent.com/AslamMahi/HoneyLogix_HoneyPot/main/assets/images/honeypot41.png",
    tags: ["Python", "ssh", "HTTP", "Linux"],
    category: "machine learning",
    github: "https://github.com/AslamMahi/Threat-Detection-and-Response-Lab",
    /*webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
  {
    id: 6,
    title: "Threat-Detection-and-Response-Lab",
    date: "September 2024",
    description:
      "Threat Detection & Response Lab offers a modular and flexible environment for security experts looking to deploy, experiment with, and evaluate security tools and technologies. By utilizing Docker.",
    image:
      "https://raw.githubusercontent.com/AslamMahi/Threat-Detection-and-Response-Lab/main/Assets/output-onlinepngtools.png",
    tags: ["Python", "ssh", "HTTP", "Linux"],
    category: "machine learning",
    github: "https://github.com/AslamMahi/HoneyLogix_HoneyPot",
    /*webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",*/
    member: [
      {
        name: "Aslam Anwar",
        img: "https://avatars.githubusercontent.com/u/137717528?v=4",
        linkedin: "https://www.linkedin.com/in/aslam-mahimkar-642a74139",
        github: "https://github.com/AslamMahi",
      },
      /*{
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },*/
    ],
  },
];

